import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy-deep px-2 py-12 sm:px-4 sm:py-16" data-id="element-88" data-mp="1hifyz98tswee">
      <div className="mx-auto max-w-3xl" data-id="element-89" data-mp="1clfuv3vje3px">
        <div className="px-2 sm:px-0" data-id="element-90" data-mp="18julvtm4i9l0">
          <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-forest-bright" data-id="element-91" data-mp="18kw0g82cle7h">
            🎁 Exclusive Bonuses
          </p>
          <h2 className="mt-3 text-center font-display text-[26px] font-black leading-tight text-white sm:text-4xl" data-id="element-92" data-mp="20b0gxvmzlh3f">
            And Today, You’ll Also Get These 5 Bonuses
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] font-medium leading-relaxed text-white/70 sm:text-lg" data-id="element-93" data-mp="1ra2j5v3565ta">
            Designed to help you save time, improve patient adherence, and make better clinical
            decisions from day one.
          </p>
        </div>

        <div className="mt-8 space-y-5" data-id="element-94" data-mp="fx9vavdh21ii">
          {bonuses.map(bonus => <article key={bonus.tag} className="flex flex-col overflow-hidden rounded-3xl border border-white/12 bg-white/[0.06]" data-id="element-95" data-mp="1eug8miixeos9">
              <div className="bg-white" data-id="element-96" data-mp="15rxc0g5qh8eg">
                <img src={bonus.image} alt={`${bonus.tag} — ${bonus.title} mockup showing book, tablet, phone and printable resources`} className="block w-full" loading="lazy" data-id="element-97" data-mp="15vbc1hqxd5iq" />
              </div>

              <div className="p-4 sm:p-5" data-id="element-98" data-mp="10v6x3w5o0ium">
                <span className="inline-block rounded-full bg-forest-bright/15 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.18em] text-forest-bright" data-id="element-99" data-mp="n30pwzkhpm7b">
                  🎁 {bonus.tag}
                </span>
                <h3 className="mt-3 font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-100" data-mp="d5ck9elciuad">
                  <span aria-hidden="true" data-id="element-101" data-mp="i22xzv9ohdsm">{bonus.emoji} </span>
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[14px] font-semibold leading-snug text-forest-bright" data-id="element-102" data-mp="2ju4tuhvc7il0">
                  {bonus.hook}
                </p>
                <p className="mt-2 text-[14px] font-medium leading-relaxed text-white/75" data-id="element-103" data-mp="2b003dzk48960">
                  {bonus.text}
                </p>
                {bonus.bullets.length > 0 && <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-104" data-mp="32rfsq1d249zx">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex gap-2" data-id="element-105" data-mp="2ypkpgrbkfmji">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-bright" aria-hidden="true" data-id="element-106" data-mp="2ynzx98cq4fot" />
                        <span className="text-[13px] font-medium leading-snug text-white/80" data-id="element-107" data-mp="2otr2sf44uco0">
                          {bullet}
                        </span>
                      </li>)}
                  </ul>}
                <div className="mt-auto flex flex-wrap items-center gap-2 pt-4" data-id="element-108" data-mp="139cbjb805xft">
                  <span className="text-[13px] font-bold text-white/50 line-through" data-id="element-109" data-mp="187e4cnv8db4h">
                    Value: {bonus.value}
                  </span>
                  <span className="rounded-full bg-forest-mid px-3 py-1 text-[11px] font-extrabold uppercase tracking-wider text-white" data-id="element-110" data-mp="1d55t590kwh4g">
                    Included free today
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-9 max-w-md px-2 sm:px-0" data-id="element-111" data-mp="1qwuabqpopvsa">
          <CTAButton label="I want the Clinical Kit + all 5 bonuses" data-id="element-112" data-mp="1vwoyhmi2s79n" />
          <p className="mt-3 text-center text-[13px] font-medium text-white/60" data-id="element-113" data-mp="1vvdv3nsjl1j2">
            Bonuses included during the launch
          </p>
        </div>
      </div>
    </section>;
}